import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

type State = {
  isUploading: boolean;
  statusText: string | null;
  setIsUploading: (value: boolean) => void;
  setStatusText: (value: string | null) => void;
  resetUploadState: () => void;
};

export const useAudioUploadStore = create<State>()(
  immer((set) => ({
    isUploading: false,
    statusText: null,
    setIsUploading: (value) => {
      set((state) => {
        state.isUploading = value;
      });
    },
    setStatusText: (value) => {
      set((state) => {
        state.statusText = value;
      });
    },
    resetUploadState: () => {
      set((state) => {
        state.isUploading = false;
        state.statusText = null;
      });
    },
  })),
);
